module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Measurement & KPIs"},"de":{"title":"Messung & KPIs"}}')
  delete Component.options._Ctor
}
